import { AxiosResponse } from "axios";

import { $axios } from "@/shared/api";

import {
  ITranscribeVoiceToTextParams,
  ITranscribeVoiceToTextResponse,
} from "../types";

class VoiceToTextService {
  async transcribeVoiceToText({
    assistantId,
    audio,
  }: ITranscribeVoiceToTextParams) {
    const formData = new FormData();

    formData.append("ai_chat_id", assistantId);
    formData.append("audio", audio);

    const response = await $axios.post<
      ITranscribeVoiceToTextParams,
      AxiosResponse<ITranscribeVoiceToTextResponse>
    >("/TranscribeVoice", formData);

    return response.data;
  }
}

export const voiceToTextService = new VoiceToTextService();
